import React from 'react'

import { Chip, ChipProps } from '@mui/material'

interface FilterChipProps extends Pick<ChipProps, 'label' | 'onClick' | 'sx'> {
  active: boolean
}

const FilterChip: React.FC<FilterChipProps> = ({ active, sx, ...props }) => (
  <Chip
    {...props}
    clickable
    color={active ? 'primary' : 'default'}
    variant={active ? 'filled' : 'outlined'}
    sx={{ fontWeight: 600, fontSize: '0.875rem', height: 34, ...sx }}
  />
)

export default FilterChip
